import $ from 'jquery';

export const init = () => {

	$(window)
		.on('resize', function(e) {
			var $content = $('.footer__inner');

			$content.removeAttr('style');

		});

};
